/**
 * Created by olga on 06.10.2026
 */

cleverapps.InitByFeature["noads"] = function () {
    cleverapps.noAds = new NoAds();
};
